import Loading from "components/loading/loading";
import { FormWidgetProvider } from "context/form.context";
import { useWidget } from "context/widget.context";
import LazyLoad from "utils/lazy-load";
import style from "./drawer.scss";
import Loadable from 'react-loadable';

const SideWidgetFormFields = Loadable({
  loader: () => import("components/form/multi-step/widget-form-fields"),
  loading: Loading
});

const CloseIcon = LazyLoad({ loader: () => import("components/icons/close/close"), });
const SuccessMessage = LazyLoad({ loader: () => import("components/layout/success-message"), });
const Copyright = LazyLoad({ loader: () => import("components/layout/copyright"), });
// const SideWidgetFormFields = LazyLoad({ loader: () => import(), loading: <Loading />});


const DrawerWidget = () => {
  const { isFormSubmitted, closeWidget, isWidgetOpen } = useWidget()
  if (!isWidgetOpen) return null
  return (
    <div className={style.drawerWrapper} >
      <div className={style.icon}>
        <Copyright />
        <CloseIcon onClick={() => closeWidget(true)} />
      </div>
      <div className={style.formWrapper}>
        {isFormSubmitted
          ? <SuccessMessage />
          : <FormWidgetProvider style={style}>
            <SideWidgetFormFields />
          </FormWidgetProvider>}
      </div>
    </div>
  )
}
export default DrawerWidget